import React from 'react';
import { Form } from './components/Form/Form';
import { ModalWindows } from './components/ModalWindows';
import { EditWatchState } from './editWatchState/EditWatchState';

export const EditWatchPage: React.FC = () => {
	return (
		<EditWatchState>
			<Form />
			<ModalWindows />
		</EditWatchState>
	);
};
